import { type VariablesOf, graphql } from '@teachino/shared-infrastructure';

export const requestCheckoutSessionDataMutation = graphql(`
  mutation RequestCheckoutSessionData(
    $licensingSessionCheckoutInput: LicensingSessionCheckoutInput!
  ) {
    requestCheckoutSessionData(
      licensingSessionCheckoutInput: $licensingSessionCheckoutInput
    ) {
      url
      gateway
    }
  }
`);
export type BillingCycle = NonNullable<
  VariablesOf<
    typeof requestCheckoutSessionDataMutation
  >['licensingSessionCheckoutInput']['billingCycle']
>;
